export const getBackgroundImage = (id: string) => {
  return { id };
};
